<script>
import ToggleableListItem from '@/components/general/ToggleableListItem'
import Breadcrumbs from '@/components/general/Breadcrumbs'
import Loading from '../../../components/general/Loading.vue'
export default {
  name: 'Support',
  components: {
    ToggleableListItem,
    Breadcrumbs,
    Loading
  },
  data () {
    return {
      isReady: false,
      company: {
        debugMode: '',
        allowSupport: '',
        allowClosedPositionAccess: false
      }
    }
  },
  created () {
    this.getSupport()
  },
  methods: {
    getSupport () {
      this.$store.dispatch('attemptGetSupport', this.$store.getters.getLanguage.substring(0, 2))
        .then(({ data }) => {
          this.company.allowSupport = data.allowSupport
          this.company.allowClosedPositionAccess = data.allowClosedPositionAccess === true
          this.isReady = true
        })
    },
    updateSupport (value) {
      this.$store.dispatch('attemptPutSupport', value)
    },
    updateClosedPositionAccess (value) {
      this.$store.dispatch('attemptPutClosedPositionAccess', value)
    }
  },
  computed: {
    breadcrumbsPaths () {
      const path = [{ text: 'admin.center:menu.6:title', href: this.$route.path }]
      return path
    }
  }
}
</script>
<template>
  <section class="support--container center-small">
  <div class="default-header">
    <breadcrumbs :items="breadcrumbsPaths"/>
    <h2>{{ $t('admin.center:menu.6:title') }}</h2>
  </div>
  <loading v-if="!isReady"/>
  <template v-else>
    <toggleable-list-item @change="val => updateSupport(val)" :item="{ inputValue: company.allowSupport, title: $t('admin.center.support:item'), description: $t('admin.center.support:item.description'), image: '/assets/images/Support/Support.png', isDisabled: false }"></toggleable-list-item>
    <toggleable-list-item @change="val => updateClosedPositionAccess(val)" :item="{ inputValue: company.allowClosedPositionAccess, title: $t('admin.center.support:closedPositionAccess.item'), description: $t('admin.center.support:closedPositionAccess.item.description'), icon: 'mdi-account-group-outline', isDisabled: false }"></toggleable-list-item>
  </template>
  </section>
</template>
